import { Component, AfterViewInit } from '@angular/core';
import { MdDialog, MdDialogRef, MdSnackBar } from '@angular/material';
import { Http, Response, Headers } from '@angular/http';
import { Guid } from './Guid';
import { DictionaryItem } from './ProxyHelper';

@Component({
    selector: 'login-panel',
    templateUrl: './app/templates/login/login.panelComponent.html'
})
export class LoginPanelComponent implements AfterViewInit {

    ngAfterViewInit() {
        var headers = new Headers();
        headers.append('Content-Type', 'application/json');

        this.http.get("./Account/GetLanguages", { headers: headers })
            .map((res: Response) => res.json()
            ).subscribe(
                (res: any) => {
                    this.LanguageId = res.languageId;
                    this.Languages = res.languages;
                },
                (error) => {

                },
                () => {
                    this.onChangeLanguage();
                }
            );
    }

    LS: any = {};
    LanguageId: string;
    Languages: DictionaryItem[] = [];
    
    login: any;
    password: any;

    message: string = "";
    loading: boolean = false;

    constructor(private http: Http) {
    }

    public enter(event: any) {

        if (!this.login) { return; }

        this.loading = true;
        this.message = '';

        var headers = new Headers();
        headers.append('Content-Type', 'application/json');

        this.http.post("./Account/LogOn", JSON.stringify({ userName: this.login, password: this.password }), { headers: headers })
            .map((res: Response) => res.json()
            ).subscribe(
                (res: any) => {
                    if (res.result == 'ok') {
                        window.location.href = "../";
                    } else if (res.result == 'error') {
                        this.message = "".concat(...res.message.split("$").map((t: any) => t in this.LS ? this.LS[t] : t));
                        this.loading = false;
                    }
                },
                (error) => {
                    this.loading = false;
                },
                () => {
                    //completed
                }
            );
    }

    onChangeLanguage() {
        var headers = new Headers();
        headers.append('Content-Type', 'application/json');

        this.http.post("./Account/GetLocalizationStrings", JSON.stringify({ id: this.LanguageId }), { headers: headers })
            .map((res: Response) => res.json()
            ).subscribe(
                (res: any) => {
                    this.LS = res;
                    document.getElementById('bodyId').style.backgroundImage = `url('../images/${this.LS._lang}/login_bg_${this.getScreenClass()}.jpg')`;
                },
                (error) => {
                    console.log(error);
                },
                () => {
                    //completed
                }
            );
    }

    private getScreenClass() {
        var date = new Date();
        var day = date.getDay();
        var hours = date.getHours();
        var minutes = date.getMinutes();

        if (day >= 1 && day <= 5) {
            if (hours >= 8 && hours <= 20)
                return "day";
            else
                return "night";
        } else {
            if ((hours >= 9 || (hours >= 8 && minutes >= 30)) && hours <= 18)
                return "day";
            else
                return "night";
        }
    };
}


// WEBPACK FOOTER //
// ./app/login.panelComponent.ts